import { render } from "./ListButtonOrg.vue?vue&type=template&id=b31a78dc"
import script from "./ListButtonOrg.vue?vue&type=script&lang=js"
export * from "./ListButtonOrg.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__